export type AnalyticsEventName =
  | "page_view"
  | "calculator_started"
  | "calculator_completed"
  | "calculator_result"
  | "live_demo_clicked"
  | "live_demo_started"
  | "demo_start"
  | "demo_complete"
  | "demo_cta_click"
  | "pricing_viewed"
  | "lead_form_started"
  | "lead_submitted"
  | "lead_submission_failed";

type EventProperties = Record<string, string | number | boolean | null | undefined>;

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

export function track(name: AnalyticsEventName, properties: EventProperties = {}): void {
  const params = new URLSearchParams(location.search);
  const campaignAttribution = {
    utm_source: params.get("utm_source") || undefined,
    utm_medium: params.get("utm_medium") || undefined,
    utm_campaign: params.get("utm_campaign") || undefined,
    utm_content: params.get("utm_content") || undefined,
    utm_term: params.get("utm_term") || undefined,
  };
  const eventProperties = { ...campaignAttribution, ...properties };
  const detail = { event: name, ...eventProperties };
  window.dataLayer?.push(detail);
  window.dispatchEvent(new CustomEvent("appsorder:analytics", { detail }));
  const payload = JSON.stringify({
    name,
    properties: eventProperties,
    page: location.pathname,
    occurred_at: new Date().toISOString(),
  });
  if (navigator.sendBeacon) {
    navigator.sendBeacon("/api/analytics", new Blob([payload], { type: "application/json" }));
  } else {
    void fetch("/api/analytics", { method: "POST", headers: { "content-type": "application/json" }, body: payload, keepalive: true }).catch(() => undefined);
  }
}
